const ClientFeatures = [
  { id: "push_offer", name: "Push offers" },
  { id: "pull_config", name: "Pull candidatos" },
  { id: "doc_request", name: "Doc request" },
  { id: "edit_fields", name: "Campos editables" },
  { id: "phases_status", name: "Fases y Estados" },
  { id: "video_analysis", name: "Video Analisis" },
  { id: "vacancy_request", name: "GPP - Vacancy request" },
  { id: "gipp_module", name: "GIPP - Gestor inteligente de peticiones de plantilla"},
  { id: "career_site", name: "Career site" },
  { id: "job_posting_draft", name: "Borrador de publicación" },
  { id: "ai_agents", name: "Agentes de IA" },
  { id: "ai_agents_text", name: "Agentes de IA: entrevistas por texto" },
  { id: "talent_loader", name: "Carga de talento" },
  { id: "recruiter_groups", name: "Grupos de reclutadores" },
  { id: "inbox_ai_search", name: "Búsqueda IA en inbox" },
  { id: "candidate_view_columns", name: "Columnas extra" },
];

const Languages = [
  { id: "es", name: "Español" },
  { id: "en", name: "Ingles" },
  { id: "pt", name: "Portugués" },
  { id: "ca", name: "Catalán" },
  { id: "fr", name: "Francés" },
  { id: "it", name: "Italiano" },
];

export { ClientFeatures, Languages };
